import { ReactComponent as ChartSelectedIcon } from './chart_selected.svg';

export default ChartSelectedIcon;
